module.exports = __webpack_public_path__ + "static/media/title.06be4581.png";